import register from '@kpsys/angularjs-register';
import {fondRoutes} from './fonds.routes';
import {FondsDataService} from './services/fonds.data-service';
import {KpFondsService} from './services/kp-fonds.service';

export default register('portaro.features.fonds')
    .config(fondRoutes)
    .service(FondsDataService.serviceName, FondsDataService)
    .service(KpFondsService.serviceName, KpFondsService)
    .name();